export enum ItemType {
    catalog = 'catalog',
    product = 'product',
}
